import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowBoxRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-box-right, login, enter, door"} maskId="square-filled-radius-0-stroke-1-IconArrowBoxRight"><path fillRule="evenodd" clipRule="evenodd" d="M20 4L14 4V3L21 3V21H14V20H20V4ZM12 7.7929L16.2071 12L12 16.2071L11.2929 15.5L14.2929 12.5L3 12.5L3 11.5L14.2929 11.5L11.2929 8.5L12 7.7929Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowBoxRight;
